import { Box, List, ListSubheader, Divider } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { NavListRoot } from './NavList';
import { NavSectionProps } from './type';

export const ListSubheaderStyle = styled((props) => (
  <ListSubheader disableSticky disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.overline,
  paddingTop: theme.spacing(0),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  color: theme.palette.text.primary,
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

export default function NavSectionVertical({
  navConfig,
  isCollapse = false,
  ...other
}: NavSectionProps) {
  const theme = useTheme();
  return (
    <>
      <Divider
        variant="middle"
        sx={{ marginTop: '8px !important', backgroundColor: theme.palette.text.primary }}
      />
      <Box {...other}>
        {navConfig.map((group, index) => (
          <List key={index} disablePadding>
            {group.items.map((list, i) => (
              <NavListRoot
                key={list.title + '_' + list.path + '_' + i}
                list={list}
                isCollapse={isCollapse}
              />
            ))}
          </List>
        ))}
      </Box>
    </>
  );
}
